module.exports = __webpack_public_path__ + "img/RMX1911.a6c5b7c1.jpg";